export const OPINION_DECISION = {
	HAND_UP: 'HAND_UP',
	HAND_DOWN: 'HAND_DOWN',
};

export const OPINION_SOURCE = {
	MESSAGE: 'MESSAGE',
	PERSON: 'PERSON',
};
